import throttle from 'throttle-debounce/throttle'

export default {
  get scrollPosition () {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

    return scrollTop / (scrollHeight - document.documentElement.clientHeight) * 100
  },
  addScrollListener (callback, delay = 50) {
    window.addEventListener('scroll', throttle(delay, callback))
  },
  addResizeListener (callback, delay = 50) {
    window.addEventListener('resize', throttle(delay, callback))
  }
}
